import { render, staticRenderFns } from "./TaskCardContent.vue?vue&type=template&id=e4735f5e&scoped=true&"
import script from "./TaskCardContent.vue?vue&type=script&lang=ts&"
export * from "./TaskCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./TaskCardContent.vue?vue&type=style&index=0&id=e4735f5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4735f5e",
  null
  
)

export default component.exports